import gql from 'graphql-tag';
import { CommentFragment } from '../fragments/comment.fragment';

export const NewCommentMutation = gql`
  mutation createPost(
    $postID: ID!
    $comment: String!
    $parentCommentID: ID
    $images: [String!]
  ) {
    createComment(
      postID: $postID
      comment: $comment
      images: $images
      parentCommentID: $parentCommentID
    ) {
      ...CommentFragment
    }
  }
  ${CommentFragment}
`;
